export const HEADER_COLOR_DEFAULT = 'primary';
export const HEADER_ACTIONS_COLOR_DEFAULT = 'primary';
export const HEADER_DIALOG_CLOSE_BUTTON_LABEL_DEFAULT = 'Close';
export const HEADER_MENU_TOGGLE_LABEL_DEFAULT = 'Menu';
